/* eslint-disable */
/* global d3, $, jQuery, Tabulator, rows, adjust, colorscale, appearancetimes, magic_padding, el, txt, my_vars, col_max, col_min, column_name, bg_color, y, cols_array, technical_colleges, support_entities, html_str2 */
// export let html_str2 = '', rows = [], adjust, colorscale, appearancetimes, magic_padding, val, val2, textsize, et, txt, my_vars = {}, col_max, col_min, column_name, bg_color, y, cols_array = [], technical_colleges = [], support_entities = [];
// const d3 = window.d3v5;
import * as d3 from "d3";

export function initLegacyCharts() {
  const tooltip = d3.select("#osa-tooltip")
  const parse_px = (px) => parseFloat(px.slice(0, -2))

  function tooltip_mousemove(event, d) { // Updated implementation
    const mouse_left = Math.max(0, event.pageX); // New implementation
    const mouse_top = event.pageY;    
    const viewportTop = window.scrollY || document.documentElement.scrollTop;
    const viewportLeft = window.scrollX || document.documentElement.scrollLeft
    const viewportBottom = viewportTop + window.innerHeight;
    const viewportRight = viewportLeft + window.innerWidth;
    const tooltip_bcr =  tooltip.node().getBoundingClientRect()
    
    let tooltip_offset_x = 25;
    let tooltip_offset_y = -tooltip_bcr.height-40;

    const edge_buffer = 20

    // Check if the tooltip will go out of bounds 

    let tt_extends_left = false 
    let tt_extends_right  = false 
    let tt_extends_bottom = false 
    let tt_extends_top = false

    if(mouse_left - tooltip_bcr.width - edge_buffer <= viewportLeft){
      tt_extends_left = true
      tooltip_offset_x = 25
    }

    if(tooltip_bcr.width + mouse_left + edge_buffer >= viewportRight){
      tt_extends_right = true
      tooltip_offset_x = -tooltip_bcr.width -25
    }

    if(mouse_top - tooltip_bcr.height - edge_buffer  <= viewportTop){
      tooltip_offset_y =  40
      tt_extends_top =  true
    }

    if(tooltip_bcr.height + mouse_top + edge_buffer >= viewportBottom){
      tt_extends_bottom = true
      tooltip_offset_y = -tooltip_bcr.height - 40
    }

    if(tt_extends_left && tt_extends_right){
      // force the tooltip to the horizontal center of the screen:
      tooltip.style("left", (window.innerWidth / 2) + "px")
    }else {
      tooltip.style("left", (mouse_left + tooltip_offset_x ) + "px")
    }

    if(tt_extends_top && tt_extends_bottom){
      // force the tooltip to the vertical center of the screen:
      tooltip.style("top", (window.innerHeight  / 2) + "px")
    }else {
      tooltip.style("top", (mouse_top +  tooltip_offset_y) + "px");
    }
  }

  const hide_tooltip = () => {
    tooltip.style.visibility = 'hidden';
  }

  // Refactored version of b.h.e.w.c
  const build_higher_ed_waffle_chart = function(){
    // New implementation below
    d3.csv("/data/acfr_ed_totals_waffle_higher_ed.csv").then(data => {
        // filter data to 2024 only
        // Added by Matt to prevent JS errors
        if (!Array.isArray(data)) {
            data = [];
        }
        data = data.filter(function(d){ return d.fiscal_year == 2024 })
        // wipe the chart
        const idcontainer = "all-spending-waffle"; // I need to change thiz plz
        d3.select("#"+idcontainer).selectAll("*").remove()

        var margin = {top: 0, right: 0, bottom: 0, left: 0};
            let icon = '';
            let rows = 10;
            let adjust = 0.7;
            let colorscale = d3.scaleOrdinal()
              .domain(["Higher Education", "Other Activities"])
              // .range(["#c85628", "#999999"]);
              .range(["#ffc63a", "#999999"]);
            let appearancetimes = function(d, i){ return 500; };
            let magic_padding = 2;

        var total = d3.sum(data, function(d) { return d.value; });

        /* updating data */
        data.forEach(function(d, i){
            data[i].class = snake_caseify(d.name);
            data[i].percent = data[i].value/total;
            data[i].dollar_val = data[i].dollar_val;
        });

        var totalscales = d3.sum(data, function(d){ return d.value; })
        var cols = Math.ceil(totalscales/rows);
        var griddata = cartesianprod(d3.range(cols), d3.range(rows));
        var detaildata = [];

        data.forEach(function(d){
            d3.range(d.value).forEach(function(e){
                detaildata.push({ name: d.name, class: d.class, dollar_val: d.dollar_val })
            });
        });

        detaildata.forEach(function(d, i){
            detaildata[i].col = griddata[i][0];
            detaildata[i].row = griddata[i][1];
        })

        var container_width = $("#"+idcontainer+"-container").width();
        var width = container_width - margin.left - margin.right;
        var height = container_width - margin.top - margin.bottom;
        var gridSize = ((height - margin.top - margin.bottom) / rows)

        d3.select("#"+idcontainer).selectAll("*").remove()

        var svg = d3
            .select("#"+idcontainer)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        const chartSelector = "#" + idcontainer + " svg";

        var nodes = svg.selectAll(".node")
            .data(detaildata)
            .enter().append("g")
            .attr("class", "node")
            .attr("transform", function(d) { return "translate(" + (d.col)*gridSize + "," + (rows - d.row - 1)*gridSize  + ")"; });

        nodes.append("text")
            .style("opacity", 0)
            .text(function(d) { return String.fromCharCode(0xf2e8); })
            .attr('class', function(d){ return d.class + " fa"; })
            .attr('font-family', 'Font Awesome 6 Free')
            .style('font-weight', 900)
            .attr("x", gridSize / 2) 
            .attr("y", 5/6 * gridSize)
            .style("text-anchor", "middle")
            .style('fill', function(d){ return colorscale(d.class); })
            .style("font-size", function(d) {
                let val = 9;
                let val2 = 2;
                let textsize = Math.min(val2 * gridSize, (val2 * gridSize - val) / this.getComputedTextLength() * val);
                return textsize * adjust + "px";
            })
            .on("mouseover", mouseover)
            .on("mouseout", mouseout)
            .on("mousemove", tooltip_mousemove)
            .transition()
            .duration(appearancetimes)
            .style("opacity", 1);

        nodes.append("rect")
            .style("fill", "white")
            .attr('class', function(d){ return d.class; })
            .style("stroke", "gray")
            .attr("width", gridSize)
            .attr("height", gridSize)
            .on("mouseover", mouseover)
            .on("mouseout", mouseout)
            .on("mousemove", tooltip_mousemove)
            .style("opacity", 0)

        var legend = d3.select("#all-spending-waffle-legend")
            .selectAll('.legend') 
            .data(data)
            .enter().append('g')
            .attr('class', function(d){ return "legend" + " " + d.class + " mr-2"})
            .attr("transform", function(d,i) { return "translate(" + magic_padding + "," + (i*gridSize  + magic_padding) + ")"; })

        legend.append('text')
            .style("opacity", 1)
            .text(function (d) { return '\uf2e8' })
            .style('fill', function(d){ return colorscale(d.class); })
            .style('color', function(d){ return colorscale(d.class); })
            .attr('class', function(d){ return d.class + " fa" })
            .attr('font-family', 'FontAwesome');

        legend.append('text')
            .style("opacity", 1)
            .html(function(d){ return d.name; })
            .attr('class', function(d){ return "waffle-legend-text" + " " + d.class + " ml-1"; });

        function mouseover(event,d){
            tooltip.transition().duration(100).style("opacity", .9);
            let el = data.filter(function(e){ return e.name == d.name})[0]
            let txt = `<b>${el.name}</b><br>$${el.dollar_val} Billion (${d3.format(".0%")(el.percent)})`
            tooltip.html(txt);

            d3.select(chartSelector).selectAll("text").transition().duration(100).style("opacity", 0.2);
            d3.select('#all-spending-waffle-legend').selectAll("text").transition().duration(100).style("opacity", 0.2);
            d3.select(chartSelector).selectAll("text.fa." + d.class).transition().duration(100).style("opacity", 1);
            d3.select(chartSelector).selectAll("text." + d.class).transition().duration(100).style("opacity", 1);
            d3.select('#all-spending-waffle-legend').selectAll("text.fa." + d.class).transition().duration(100).style("opacity", 1);
            d3.select('#all-spending-waffle-legend').selectAll("text." + d.class).transition().duration(100).style("opacity", 1);
        }

        function mouseout(event, d){
            tooltip.transition().duration(100).style("opacity", 0);
            d3.select(chartSelector).selectAll("text").transition().duration(100).style("opacity", 1);
            d3.select('#all-spending-waffle-legend').selectAll("text").transition().duration(100).style("opacity", 1);
        }

        function tooltip_mousemove(event, d){
            tooltip.style("left", (event.pageX + 10) + "px")
                   .style("top", (event.pageY - 28) + "px");
        }

    }).catch(error => {
        console.log("There is an error: ",error)
    })
  }// end build_higher_ed_waffle_chart

  // Refactored version of b.h.e.o.b
  const build_higher_exp_overtime_barchart = function() {
    // Build the Barchart
    // Updated D3 Implementation - Load CSV data
    d3.csv("/data/acfrs_higher_ed_totals.csv").then(rawData => {
        const data_arr = rawData.map(d => ({
            fiscal_year: +d.fiscal_year,
            higher_ed: +d.higher_ed.replace(/,/g, ''),
            yearly_change: +d.yearly_change.replace(/,/g, '')
        }));

        let data = Array.isArray(data_arr)
            ? data_arr.filter(el => el.fiscal_year >= 2004)
            : [];

        const idcontainer = "higher-ed-overtime-barchart";

        const getChartDimensions = (idcontainer) => {
            const container_width = $("#" + idcontainer + "-container").width();
            const isLargeScreen = window.matchMedia("(min-width: 768px)").matches;

            const margin = isLargeScreen
                ? { top: 10, right: 10, bottom: 80, left: 100 }
                : { top: 10, right: 10, bottom: 60, left: 50 };

            const width = container_width - margin.left - margin.right;
            const height = 3 * container_width / 4 - margin.top - margin.bottom;

            const x_axis_label_offset = isLargeScreen ? 60 : 25;
            const y_axis_label_offset = 0;

            return { width, height, margin, x_axis_label_offset, y_axis_label_offset };
        }

        let { width, height, margin, x_axis_label_offset, y_axis_label_offset } = getChartDimensions(idcontainer);

        d3.select("#" + idcontainer).selectAll("*").remove();

        var svg = d3.select("#" + idcontainer)
            .append("svg")
            .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
            .attr("preserveAspectRatio", "xMidYMid meet")
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        const chartSelector = "#" + idcontainer + " svg";

        var x = d3.scaleBand()
            .range([0, width])
            .domain(data.map(d => d.fiscal_year))
            .padding(0.2);

        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .attr("class", "axisWhite")
            .call(d3.axisBottom(x).ticks(d3.timeYear.every(1), d3.utcFormat("%y")))
            .selectAll("text")
            .attr("transform", function() {
                return "translate(-" + (this.getBBox().width / 5) + ", " + (this.getBBox().height / 4) + ") rotate(-45)";
            })
            .style("text-anchor", "end");

        svg.append("text")
            .attr("class", "axisLabelWhite")
            .attr("transform", "translate(" + width / 2 + " ," + (height + margin.top + x_axis_label_offset) + ")")
            .style("text-anchor", "middle")
            .style("fill", "#fff")
            .text("Fiscal Year");

        var val_max = d3.max(data, d => d.higher_ed);

        var formatDollarBillions = val => d3.format("$.3s")(val).replace(/G/, "B");
        var formatDollarBillions2 = val => d3.format("$.2s")(val).replace(/G/, "B");

        var y = d3.scaleLinear()
            .domain([0, val_max])
            .range([height, 0]);

        svg.append("g")
            .attr("class", "axisWhite")
            .call(d3.axisLeft(y).tickFormat(formatDollarBillions2));

        svg.append("text")
            .attr("class", "axisLabelWhite")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - margin.left)
            .attr("x", 0 - height / 2)
            .attr("dy", "1em")
            .style("text-anchor", "middle")
            .style("fill", "#fff")
            .text("Expenditure $");

        const tooltip = d3.select("body")
            .append("div")
            .attr("class", "tooltip")
            .style("opacity", 0)
            .style("position", "absolute")
            .style("pointer-events", "none")
            .style("background", "#fff")
            .style("border", "1px solid #ccc")
            .style("padding", "8px")
            .style("border-radius", "4px");

        function mouseover(event, d) {
            tooltip.transition().duration(100).style("opacity", 0.9);
            let txt;
            if (d.fiscal_year == 2019) {
                txt = `<b>Year: ${d.fiscal_year}</b><br>Higher Ed Expenditure: <div class="badge badge-secondary"><p class="lead my-0">${formatDollarBillions(d.higher_ed)} Billion</p></div><br>`;
            } else {
                txt = `<b>Year: ${d.fiscal_year}</b><br>Higher Ed Expenditure: <div class="badge badge-secondary"><p class="lead my-0">${formatDollarBillions(d.higher_ed)} Billion</p></div><br>Change: ${formatDollarBillions(d.yearly_change)} Million`;
            }
            tooltip.html(txt);

            d3.select(chartSelector).selectAll("rect").transition().duration(100).style("opacity", 0.2);
            d3.select(this).transition().duration(100).style("opacity", 1);
        }

        function mouseout(event, d) {
            tooltip.transition().duration(100).style("opacity", 0);
            d3.select(chartSelector).selectAll("rect").transition().duration(100).style("opacity", 1);
        }

        function tooltip_mousemove(event, d) {
            tooltip.style("left", (event.pageX + 10) + "px")
                   .style("top", (event.pageY - 28) + "px");
        }

        svg.selectAll("mybar")
            .data(data)
            .enter()
            .append("rect")
            .attr("x", d => x(d.fiscal_year))
            .attr("width", x.bandwidth())
            .attr("class", d => 'rect_' + d.fiscal_year)
            .attr("fill", "#ffc63a")
            .attr("y", d => y(d.higher_ed))
            .attr("height", d => height - y(d.higher_ed))
            .on("mouseover", mouseover)
            .on("mouseout", mouseout)
            .on("mousemove", tooltip_mousemove);

      }).catch(error => {
          console.log("There is an error loading CSV or building chart: ", error);
      });
  };

  // Refactored version of b.h.e.p.o.b
  const build_higher_exp_perc_overtime_barchart = function() {
    // Build the Barchart
    d3.csv("/data/acfrs_higher_ed_totals.csv").then(rawData => {

      // Parse CSV numeric fields to avoid NaN/undefineds
      const data_arr = rawData.map(d => ({
        fiscal_year: +d.fiscal_year,
        higher_ed: +d.higher_ed.replace(/,/g, ''),
        higher_ed_perc: +d.higher_ed_perc,
        yearly_change: +d.yearly_change.replace(/,/g, '')
      }));

      let data = Array.isArray(data_arr)
        ? data_arr.filter(el => el.fiscal_year >= 2004)
        : [];

      const idcontainer = "higher-ed-overtime-perc-budget";
      d3.select("#" + idcontainer).selectAll("*").remove();

      // Added for responsive dimensions
      const getChartDimensions = (idcontainer) => {
        const container_width = $("#" + idcontainer + "-container").width();
        const isLargeScreen = window.matchMedia("(min-width: 768px)").matches;

        const margin = isLargeScreen
          ? { top: 10, right: 10, bottom: 80, left: 100 }
          : { top: 10, right: 10, bottom: 60, left: 50 };

        const width = container_width - margin.left - margin.right;
        const height = 3 * container_width / 4 - margin.top - margin.bottom;

        const x_axis_label_offset = isLargeScreen ? 60 : 25;
        const y_axis_label_offset = 0;

        return { width, height, margin, x_axis_label_offset, y_axis_label_offset };
      }

      let { width, height, margin, x_axis_label_offset, y_axis_label_offset } = getChartDimensions(idcontainer);

      // Add the svg element to the body and set the dimensions and margins of the graph
      var svg = d3.select(`#${idcontainer}`)
        .append("svg")
        // .attr("width", width + margin.left + margin.right)
        // .attr("height", height + margin.top + margin.bottom)
        .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`) // Added for responsive behavior
        .attr("preserveAspectRatio", "xMidYMid meet") // Added for responsive behavior
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      // X axis scale
      var x = d3.scaleBand()
        .range([0, width])
        .domain(data.map(d => d.fiscal_year))
        .padding(0.2);

      // Add x axis
      svg.append("g")
        .attr("transform", `translate(0,${height})`)
        .attr("class", "axisWhite")
        .call(d3.axisBottom(x).ticks(d3.timeYear.every(1), d3.utcFormat("%y")))
        .selectAll("text")
        .attr("transform", function() {
          return `translate(-${this.getBBox().width / 5}, ${this.getBBox().height / 4}) rotate(-45)`;
        })
        .style("text-anchor", "end");

      // X axis label
      svg.append("text")
        .attr("class", "axisLabelWhite")
        .attr("transform", `translate(${width / 2},${height + margin.top + x_axis_label_offset})`)
        .style("text-anchor", "middle")
        .style("fill", "#fff")
        .text("Fiscal Year");

      // Y axis scale
      var y = d3.scaleLinear()
        .domain([0, 0.12])
        .range([height, 0]);

      var formatPercent = d3.format(".1%");

      // Add Y axis
      svg.append("g")
        .attr("class", "axisWhite")
        .call(d3.axisLeft(y).tickFormat(formatPercent));

      // Y axis label
      svg.append("text")
        .attr("class", "axisLabelWhite")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - margin.left)
        .attr("x", 0 - (height / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("fill", "#fff")
        .text("Percent of Total Expenditure");

      // Tooltip
      const tooltip = d3.select("body")
        .append("div")
        .attr("class", "tooltip higher-ed-perc-tooltip")
        .style("opacity", 0)
        .style("position", "absolute")
        .style("pointer-events", "none")
        .style("background", "#fff")
        .style("border", "1px solid #ccc")
        .style("padding", "8px")
        .style("border-radius", "4px");

      function mouseover(event, d) {
        tooltip.transition().duration(100).style("opacity", 0.9);
        const txt = `<b>Year: ${d.fiscal_year}</b><br>Percent of Total Expenditure: 
                    <div class="badge badge-secondary">
                      <p class="lead my-0">${formatPercent(d.higher_ed_perc)}</p>
                    </div>`;
        tooltip.html(txt);

        // Scope transitions only to this chart’s SVG
        svg.selectAll("rect").transition().duration(100).style("opacity", 0.2);
        d3.select(this).transition().duration(100).style("opacity", 1);
      }

      function mouseout(event, d) {
        tooltip.transition().duration(100).style("opacity", 0);
        svg.selectAll("rect").transition().duration(100).style("opacity", 1);
      }

      function tooltip_mousemove(event, d) {
        tooltip.style("left", (event.pageX + 10) + "px")
              .style("top", (event.pageY - 28) + "px");
      }

      // Draw bars
      svg.selectAll("mybar")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", d => x(d.fiscal_year))
        .attr("width", x.bandwidth())
        .attr("class", d => `rect_${d.fiscal_year}`)
        .attr("fill", "#ffc63a")
        .attr("y", d => y(d.higher_ed_perc))
        .attr("height", d => height - y(d.higher_ed_perc))
        .on("mouseover", mouseover)
        .on("mouseout", mouseout)
        .on("mousemove", tooltip_mousemove);

    }).catch(error => {
      console.log("There is an error loading CSV or building chart: ", error);
    });
  }; // end build_higher_exp_perc_overtime_barchart

  // Refactored version of build_institution_exp_barchart
  window.build_institution_exp_barchart = function () {
    // Load CSV data
    d3.csv("/data/appr_summary.csv").then(data_response => {
      // Filter to 2024 and sort ascending by total expenditure
      const data = (Array.isArray(data_response)
        ? data_response.filter(d => +d.fiscal_year === 2024)
        : []
      ).sort((a, b) => +a.total - +b.total);

      const idcontainer = "state-expenditures-barchart";

      // Clear previous SVG
      d3.select("#" + idcontainer).selectAll("*").remove();

      // Responsive margins
      let margin = { top: 10, right: 10, bottom: 65, left: 100 };
      let x_axis_label_offset = 45;
      if (window.matchMedia("(min-width: 768px)").matches) {
        margin = { top: 10, right: 10, bottom: 80, left: 100 };
        x_axis_label_offset = 60;
      }

      const container_width = $("#" + idcontainer + "-container").width();
      const width = container_width - margin.left - margin.right;
      const height = container_width * 0.75 - margin.top - margin.bottom;

      // Create SVG
      const svg = d3.select("#" + idcontainer)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      // Y scale
      const y = d3.scaleBand()
        .range([height, 0])
        .domain(data.map(d => d.entity_name_abbr))
        .padding(0.2);

      // Updated Add Y axis
      const yAxis = svg.append("g")
        .call(d3.axisLeft(y));

      yAxis.selectAll("text")
        .style("fill", "#000")
        .style("text-anchor", "end");

      yAxis.selectAll("path, line")
        .style("stroke", "#000")
        .style("stroke-width", "1px");

      // X scale
      const val_max = d3.max(data, d => +d.total);
      const x = d3.scaleLinear()
        .domain([0, val_max])
        .range([0, width]);

      const formatDollarBillions = d3.format("$.2s");

      // Updated Add X axis
      const xAxis = svg.append("g")
        .attr("transform", `translate(0, ${height})`)
        .call(d3.axisBottom(x).tickFormat(formatDollarBillions));

      xAxis.selectAll("text")
        .attr("transform", "rotate(-45)")
        .style("fill", "#000")
        .style("text-anchor", "end");

      xAxis.selectAll("path, line")
        .style("stroke", "#000")
        .style("stroke-width", "1px");

      // X axis label
      svg.append("text")
        .attr("transform", `translate(${width/2}, ${height + margin.top + x_axis_label_offset})`)
        .style("text-anchor", "middle")
        .text("Expenditure");

      // Tooltip (scoped to this chart)
      const tooltipId = idcontainer + "-tooltip";
      d3.select(`#${tooltipId}`).remove(); // remove old tooltip if any
      const tooltip = d3.select("body")
        .append("div")
        .attr("id", tooltipId)
        .attr("class", "tooltip")
        .style("opacity", 0)
        .style("position", "absolute")
        .style("background", "#fff")
        .style("border", "1px solid #ccc")
        .style("padding", "8px")
        .style("border-radius", "4px")
        .style("z-index", 1000);

      function mouseover(event, d) {
        tooltip.transition().duration(100).style("opacity", 0.9);

        tooltip.html(`
          <div>
            <p class="my-1"><strong>Year: </strong> ${d.fiscal_year}</p>
            <p class="my-1"><strong>Institution: </strong> ${d.entity_name}</p>
              <span class="badge badge-secondary p-1">
                ${d3.format("$.3s")(d.total)}
              </span>
          </div>
        `);

        // Scope bar opacity to this chart
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 0.2);
        d3.selectAll(`#${idcontainer} rect.rect_${d.entity_name_snake}`).transition().duration(100).style("opacity", 1);
      }

      function mouseout(event, d) {
        tooltip.transition().duration(100).style("opacity", 0);
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 1);
      }

      function tooltip_mousemove(event, d) {
        tooltip.style("left", (event.pageX + 10) + "px")
              .style("top", (event.pageY - 28) + "px");
      }

      // Draw bars
      svg.selectAll("rect")
        .data(data)
        .enter()
        .append("rect")
        .attr("y", d => y(d.entity_name_abbr))
        .attr("height", y.bandwidth())
        .attr("class", d => `rect_${d.entity_name_snake}`)
        .attr("fill", "#ffc63a")
        .attr("x", 0)
        .attr("width", d => x(+d.total))
        .on("mouseover", mouseover)
        .on("mouseout", mouseout)
        .on("mousemove", tooltip_mousemove);

      // Build table with Tabulator
      const tableConfig = {
        data: data,
        layout: window.matchMedia("(min-width: 992px)").matches ? "fitColumns" : "fitDataFill",
        initialSort: [{ column: "total", dir: "desc" }],
        columns: window.matchMedia("(min-width: 992px)").matches ? [
          { title: "Institution", field: "entity_name" },
          { title: "Total 2024", field: "total", sorter: "number", formatter: "money", formatterParams: { symbol: "$", precision: 0 } }
        ] : [
          { title: "Institution", field: "entity_name_abbr" },
          { title: "Total 2024", field: "total", sorter: "number", formatter: "money", formatterParams: { symbol: "$", precision: 0 } }
        ]
      };
      new Tabulator("#state-expenditures-table", tableConfig);

    }).catch(error => {
      console.error("Error loading CSV for build_institution_exp_barchart:", error);
    });
  }; // End build_institution_exp_barchart

  // Original Version - causing some small issues
  // const build_activities_highlight_table = function(){
  // } // end new build_activities_highlight_table

  // Updated Version - causing some issues with responsiveness for the page
  const build_activities_highlight_table = function(){
    // Heatmap Table

    //Added to help with responiveness issues
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Rebuild chart/table on resize (debounced)
        build_activities_highlight_table();
      }, 400);
    });
    
    // New D3 version
    d3.csv("/data/activities_agg.csv").then(dataResponse => {
      const data = Array.isArray(dataResponse) 
      ? dataResponse.filter(el => el.fy_2024 != 0) 
      : [];

      let my_vars = ["fy_2019","fy_2020","fy_2021", "fy_2022", "fy_2023", "fy_2024","fy_2024_perc", "five_year_change", "five_year_change_perc", "change", "change_perc"]

      let max_min_holder ={}

      // for each variable name in the my_vars array, apply the reduce function to find the max and add it to the 
      my_vars.forEach(variable_name => {
        let col_max =  Math.max(...data.map(row => row[variable_name]))
        let col_min =  Math.min(...data.map(row => row[variable_name]))
        max_min_holder[variable_name] = {"max" : col_max, "min":col_min}
      });

      // Create a Linear Gradient / Legend:
      d3.select("#highlight-table-legend").selectAll("*").remove()
      d3.select("#highlight-table-legend2").selectAll("*").remove()

      // const width = $("#highlight-table-legend").width() // Removed for mobile responsiveness issues

      const width = Math.max($("#highlight-table-legend").width(), 300) // Added to help with mobile responsive issues

      var svg = d3
        .select("#highlight-table-legend")
        .append("svg")
        // .attr("width", width) // Removed to help with responsiveness issues
        .attr("width", "100%") // Added to help with responsiveness issues
        .attr("preserveAspectRatio", "xMidYMid meet") // Added to help with responsiveness issues
        .attr("height", "50px")

      //Append a defs (for definition) element to your SVG
      var defs = svg.append("defs");

      //Append a linearGradient element to the defs and give it a unique id
      var linearGradient = defs.append("linearGradient")
          .attr("id", "linear-gradient");

      //Horizontal gradient
      linearGradient
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "100%")
        .attr("y2", "0%");

        //Set the color for the start (0%)
      linearGradient.append("stop")
        .attr("offset", "0%")
        .attr("stop-color", "#f8f9fa"); //light white

      //Set the color for the end (100%)
      linearGradient.append("stop")
        .attr("offset", "100%")
        .attr("stop-color", "#e9cf72"); //dark yellow

      //Draw the rectangle and fill with gradient
      svg.append("rect")
        .attr("width", width)
        .attr("height", 25)
        .style("fill", "url(#linear-gradient)")
        .style("stroke","var(--grey200)");

      // Add text labels:
      svg.append("text")
        .attr("x", 0)
        .attr("y", 45)
        .text("Low ")
        .style("text-anchor", "start");

      // Add text labels:
      svg.append("text")
        .attr("x", width)
        .attr("y", 45)
        .text("High")
          .style("text-anchor", "end");

        var svg2= d3
        .select("#highlight-table-legend2")
        .append("svg")
        .attr("width", "100%")
        .attr("height", "50px")

      //Append a defs (for definition) element to your SVG
      var defs = svg2.append("defs");

      //Append a linearGradient element to the defs and give it a unique id
      var linearGradient2 = defs.append("linearGradient")
          .attr("id", "linear-gradient2");

      //Horizontal gradient
      linearGradient2
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "100%")
        .attr("y2", "0%");

      //   //Set the color for the start (0%)
      // linearGradient.append("stop")
      //   .attr("offset", "0%")
      //   .attr("stop-color", "#f8f9fa"); //light white

      // //Set the color for the end (100%)
      // linearGradient.append("stop")
      //   .attr("offset", "100%")
      //   .attr("stop-color", "#e9cf72"); //dark yellow

      linearGradient2.selectAll("stop")
      .data([
          {offset: "0%", color: "#3d4766"},
          {offset: "50%", color: "#f8f9fa"},
          {offset: "100%", color: "#af4646"},
        ])
      .enter().append("stop")
      .attr("offset", function(d) { return d.offset; })
      .attr("stop-color", function(d) { return d.color; });

      //A color scale
      var legendScale = d3.scaleLinear()
      .domain([-1, 0 , 1])
      .range(["#3d4766", "#f8f9fa", "#af4646"])

      //Append multiple color stops by using D3's data/enter step
      linearGradient2.selectAll("stop")
        .data( legendScale.range() )
        .enter().append("stop")
        .attr("offset", function(d,i) { return i/(legendScale.range().length-1); })
        .attr("stop-color", function(d) { return d; });

      //Draw the rectangle and fill with gradient
      svg2.append("rect")
        .attr("width", width)
        .attr("height", 25)
        .style("fill", "url(#linear-gradient2)")
        .style("stroke","var(--grey200)");

      // Add text labels:
      svg2.append("text")
        .attr("x", 0)
        .attr("y", 45)
        .text("Negative High")
            .style("text-anchor", "start");

      // Add text labels:
      svg2.append("text")
      .attr("x", (width/2))
      .attr("y", 45)
      .text("0 (Low) ")
        .style("text-anchor", "middle");

      // Add text labels:
      svg2.append("text")
        .attr("x", width)
        .attr("y", 45)
        .text("High")
          .style("text-anchor", "end");

      var money_abbreviation_sequential_scale_format = function(cell, formatterParams, onRendered){

        const cell_value = cell.getValue()

        // get the entire cell's row contents so we can build a color ramp

        let column_name = cell.getField()
        var max_val = max_min_holder[column_name]["max"] +1
        var min_val = max_min_holder[column_name]["min"]

        // Now build a custom color ramp using d3
        // const column_extent = d3.extent(data, d => d)
        // const colorScale = d3.scaleSequential(d3.interpolateReds)
        //                       .domain([min_val, max_val])	

        const colorScale = d3.scaleSequential(d3.interpolateRgb("#f8f9fa", "#e9cf72"))
                              .domain([min_val, max_val])	

        const bg_color = colorScale(cell_value)
        const text_color = getContrastYIQ(bg_color)

        // determine color based on heatmap color scale...
        cell.getElement().style.backgroundColor = bg_color;
        cell.getElement().style.color=text_color;

        // SI units use "G" for Gamma but I want it to say B for billions. [insert austin powers dr evil asci art here lol]
        
        return d3.format("$.3s") (cell_value).replace(/G/,"B")
      }

      var money_abbreviation_diverging_scale_format = function(cell, formatterParams, onRendered) {
        const cell_value = cell.getValue()

        // get the entire cell's row contents so we can build a color ramp

        let column_name = cell.getField()
        var max_val = max_min_holder[column_name]["max"] +1
        var min_val = max_min_holder[column_name]["min"]

        // Now build a custom color ramp using d3
        // const column_extent = d3.extent(data, d => d)
        const colorScale = d3.scaleDiverging(d3.interpolateRgbBasis(["#3d4766","#ddedff", "#fff","#d7a3a3", "#af4646"]))
                              .domain([min_val, 0, max_val])	

        const bg_color = colorScale(cell_value)
        const text_color = getContrastYIQ(bg_color)

        // determine color based on heatmap color scale...
        cell.getElement().style.backgroundColor = bg_color;
        cell.getElement().style.color=text_color

        // SI units use "G" for Gamma but I want it to say B for billions. [insert austin powers dr evil asci art here lol]
        
        return d3.format("$.3s") (cell_value).replace(/G/,"B")
      }

      var percent_diverging_scale_format = function(cell, formatterParams, onRendered){
        const cell_value = cell.getValue()
        // get the entire cell's row contents so we can build a color ramp
        let column_name = cell.getField()
        var max_val = max_min_holder[column_name]["max"] +1
        var min_val = max_min_holder[column_name]["min"]

        // Now build a custom color ramp using d3
        // const column_extent = d3.extent(data, d => d)
        // const colorScale = d3.scaleDiverging(t => d3.interpolateRdBu(1 - t))
        //                       .domain([min_val, 0 ,max_val])	

        const colorScale = d3.scaleDiverging(d3.interpolateRgbBasis(["#3d4766","#ddedff", "#fff","#d7a3a3", "#af4646"]))
                              .domain([min_val, 0, max_val])	

        const bg_color = colorScale(cell_value)
        
        const text_color = getContrastYIQ(bg_color)

        // determine color based on heatmap color scale...
        cell.getElement().style.backgroundColor = bg_color;
        cell.getElement().style.color=text_color

        // SI units use "G" for Gamma but I want it to say B for billions. [insert austin powers dr evil asci art here lol]
        
        return d3.format(".3%") (cell_value)        
      }

      var percent_sequential_scale_format = function(cell, formatterParams, onRendered){

        const cell_value = cell.getValue()

        // get the entire cell's row contents so we can build a color ramp

        let column_name = cell.getField()
        var max_val = max_min_holder[column_name]["max"] +.001

        // Now build a custom color ramp using d3
        // const column_extent = d3.extent(data, d => d)
        const colorScale = d3.scaleSequential(d3.interpolateRgb("#f8f9fa", "#e9cf72"))
                              .domain([ 0 ,max_val])	

        const bg_color = colorScale(cell_value)
        const text_color = getContrastYIQ(bg_color)

        // determine color based on heatmap color scale...
        cell.getElement().style.backgroundColor = bg_color;
        cell.getElement().style.color=text_color

        // SI units use "G" for Gamma but I want it to say B for billions. [insert austin powers dr evil asci art here lol]
        return d3.format(".3%") (cell_value)
      }

      var collapsed_money_abbreviation_sequential_scale_format = function(cell, formatterParams, onRendered){
        const cell_value = cell.getValue()

        // get the entire cell's row contents so we can build a color ramp

        column_name = cell.getField()
        var max_val = max_min_holder[column_name]["max"] +1
        var min_val = max_min_holder[column_name]["min"]
        const colorScale = d3.scaleSequential(d3.interpolateRgb("#f8f9fa", "#e9cf72"))
                              .domain([min_val, max_val])	
        
        const text_color = getContrastYIQ(bg_color)

        // determine color based on heatmap color scale...
        cell.getElement().style.color=text_color;

        // SI units use "G" for Gamma but I want it to say B for billions. [insert austin powers dr evil asci art here lol]
        return d3.format("$.3s") (cell_value).replace(/G/,"B")
      }

      var table = new Tabulator("#all-activities-heatmap-table", {
        data:data, //set initial table data
        // layout:"fitDataFill", // Removed due to responsiveness issues
        layout: "fitColumns", // Added to help with responsiveness issues 
        responsiveLayout:"collapse",
        columnMinWidth: 100, // Added to help with responsiveness issues
        autoColumns: false, // Added to help with responsiveness issues
        responsiveLayoutCollapseUseFormatters:false,

        responsiveLayoutCollapseFormatter:function(data){
          //data - an array of objects containing the column title and value for each cell
          var list = document.createElement("ul");
  
          data.forEach(function(col){
              let item = document.createElement("li");
              var clean_val= ""
              // format the value depending on the column:
              if(col.title =="2024" || col.title =="Change 2024-2023"){
                clean_val = d3.format("$.3s") (col.value).replace(/G/,"B")
              }

              if(col.title == "Percent of Total" || col.title == "Percent Change"){
                clean_val = d3.format(".3%") (col.value)
              }

              item.innerHTML = "<strong>" + col.title + "</strong> - " + clean_val;
              list.appendChild(item);
          });
  
          return Object.keys(data).length ? list : "";
      },

        rowHeader:{formatter:"responsiveCollapse",
           width:30, minWidth:30, 
           hozAlign:"center", 
           resizable:false, 
           headerSort:false},

        initialSort:[{column:"fy_2024", dir:"desc"}],
        columns:[
            {title:"Activity", field:"activity",responsive:0}, // sticky column
            // {title:"2019", field:"fy_2019", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
            // {title:"2020", field:"fy_2020", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
            // {title:"2021", field:"fy_2021", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
            // {title:"2022", field:"fy_2022", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
            // {title:"2023", field:"fy_2023", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
            {title:"2024", field:"fy_2024", sorter:"number", formatter: money_abbreviation_sequential_scale_format,responsive:1},
            // {title:"Change 24-20", field:"five_year_change", sorter:"number",formatter:money_abbreviation_diverging_scale_format},
            // {title:"Change 24-20 %", field:"five_year_change_perc", sorter:"number", formatter:percent_diverging_scale_format},
            {title:"Percent of Total", field:"fy_2024_perc", sorter:"number", formatter:percent_sequential_scale_format},
            {title:"Change 2024-2023", field:"change", sorter:"number", formatter: money_abbreviation_diverging_scale_format},
            {title:"Percent Change", field:"change_perc", sorter:"number", formatter:percent_diverging_scale_format},
            {title:"activity_sort", field:"activity_sort", sorter:"number", visible:false},
        ],
        rowFormatter: function(row){
          if(row.getData().activity=="Higher Education"){
            const children = row.getElement().childNodes;
            children.forEach((child)=>{
              child.style.fontWeight=900
            })
          }
        }
      });
    })
  } // end new build_activities_highlight_table

  // Build the Barchart for the institution expenditure over time
  // Refactored version of BEBIB with improved tooltips - now working properly
  const build_expenditure_by_institution_barchart = function(entities, fiscal_years) {
    entities = entities || window.selectedEntities || [];
    fiscal_years = fiscal_years || window.selectedYears?.map(Number) || [];

    d3.csv("/data/appr_summary.csv").then(nextDataResponse => {
      let data = Array.isArray(nextDataResponse)
        ? nextDataResponse
            .filter(el => fiscal_years.includes(+el.fiscal_year) && entities.includes(el.entity_name))
            .sort((a, b) => a.total - b.total)
        : [];

      const idcontainer = "institution-bar-chart";
      d3.select("#" + idcontainer).selectAll("*").remove();
      $("#institution-bar-chart-container").empty();
      $("#institution-bar-chart-container").append(`<div id="institution-bar-chart"></div>`);

      // let x_axis_label_offset = 25;
      // let y_axis_label_offset = 0;
      // let margin = { top: 10, right: 10, bottom: 60, left: 50 };
      // if (window.matchMedia("(min-width: 768px)").matches) {
      //   margin = { top: 10, right: 10, bottom: 80, left: 100 };
      //   x_axis_label_offset = 60;
      // }

      // const container_width = $("#" + idcontainer + "-container").width();
      // const width = container_width - margin.left - margin.right;
      // const height = 3 * container_width / 4 - margin.top - margin.bottom;

      // Added for responsive dimensions
      const getChartDimensions = (idcontainer) => {
        const container_width = $("#" + idcontainer + "-container").width();
        const isLargeScreen = window.matchMedia("(min-width: 768px)").matches;

        const margin = isLargeScreen
          ? { top: 10, right: 10, bottom: 80, left: 100 }
          : { top: 10, right: 10, bottom: 60, left: 50 };

        const width = container_width - margin.left - margin.right;
        const height = 3 * container_width / 4 - margin.top - margin.bottom;

        const x_axis_label_offset = isLargeScreen ? 60 : 25;
        const y_axis_label_offset = 0;

        return { width, height, margin, x_axis_label_offset, y_axis_label_offset };
      }

      let { width, height, margin, x_axis_label_offset, y_axis_label_offset } = getChartDimensions(idcontainer);

      const svg = d3.select("#" + idcontainer)
        .append("svg")
        .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`) // Added for responsive behavior
        .attr("preserveAspectRatio", "xMidYMid meet") // Added for responsive behavior
        // .attr("width", width + margin.left + margin.right)
        // .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      // X axis
      const x = d3.scaleBand()
        .range([0, width])
        .domain(data.map(d => d.fiscal_year))
        .padding(0.2);

      svg.append("g")
        .attr("class", "axisBlack")
        .attr("transform", `translate(0,${height})`)
        .call(d3.axisBottom(x).ticks(d3.timeYear.every(1), d3.utcFormat("%y")))
        .selectAll("text")
        .attr("transform", "rotate(-45)")
        .style("text-anchor", "end");

      svg.append("text")
        .attr("class", "axisLabelBlack")
        .attr("transform", `translate(${width / 2}, ${height + margin.top + x_axis_label_offset})`)
        .style("text-anchor", "middle")
        .text("Fiscal Year");

      // Tooltip
      const tooltipId = `${idcontainer}-tooltip`;
      d3.select(`#${tooltipId}`).remove(); // Remove existing tooltip for this chart
      const tooltip = d3.select(`#${idcontainer}-container`)
        .append("div")
        .attr("id", tooltipId)
        .attr("class", "tooltip")
        .style("opacity", 0)
        .style("position", "absolute")
        .style("pointer-events", "none")
        .style("background", "#fff")
        .style("border", "1px solid #ccc")
        .style("padding", "8px")
        .style("border-radius", "4px")
        .style("z-index", 1000);

      const formatDollarBillions = val => d3.format("$.3s")(val).replace(/G/, "B");
      const formatDollarBillions2 = val => d3.format("$.2s")(val).replace(/G/, "B");

      // Y axis
      const val_max = d3.max(data, d => +d.total);
      const y = d3.scaleLinear().domain([0, val_max]).range([height, 0]);

      svg.append("g")
        .attr("class", "axisBlack")
        .call(d3.axisLeft(y).tickFormat(formatDollarBillions2));

      svg.append("text")
        .attr("class", "axisLabelBlack")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - margin.left - y_axis_label_offset)
        .attr("x", 0 - height / 2)
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text("Expenditure $");

      // Draw bars
      svg.selectAll("mybar")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", d => x(d.fiscal_year))
        .attr("width", x.bandwidth())
        .attr("fill", "#ffc63a")
        .attr("y", d => y(d.total))
        .attr("height", d => height - y(d.total))
        .on("mouseover", mouseover)
        .on("mouseout", mouseout)
        .on("mousemove", tooltip_mousemove);

      function mouseover(event, d) {
        tooltip.transition().duration(100).style("opacity", 0.9);
        tooltip.html(`
          <div>
            <p class="my-1"><strong>Institution:</strong> ${d.entity_name}</p>
            <p class="my-1"><strong>Year:</strong> ${d.fiscal_year}</p>
            <p class="my-1"><strong>Expenditure:</strong> 
              <span class="badge badge-secondary p-1">
                ${formatDollarBillions(d.total)}
              </span>
            </p>
          </div>
        `);
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 0.2);
        d3.select(this).transition().duration(100).style("opacity", 1);
      }

      function mouseout(event, d) {
        tooltip.transition().duration(100).style("opacity", 0);
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 1);
      }

      function tooltip_mousemove(event, d) {
        tooltip.style("left", (event.offsetX + 10) + "px")
               .style("top", (event.offsetY - 28) + "px");
      }

    });

    window.build_expenditure_by_institution_barchart = build_expenditure_by_institution_barchart;
  };

  // New version - shows data
  const build_expenditure_by_institution_table = function(entities, fiscal_years){
    entities = entities || window.selectedEntities || [];
    fiscal_years = fiscal_years || window.selectedYears?.map(Number) || [];

    // Updated New D3 Method
    d3.csv("/data/appr_summary.csv").then(currentDataResponse => {
      let data = Array.isArray(currentDataResponse)
      ? currentDataResponse
          .filter(el => fiscal_years.includes(+el.fiscal_year) && entities.includes(el.entity_name))
          .sort((a, b) => a.total - b.total)
      : [];

      var money_formatter = function(cell, formatterParams, onRendered){  
        const cell_value = cell.getValue()
  
        return d3.format("$,.0f") (cell_value).replace(/G/,"B")
      }
  
      var table = new Tabulator("#institution-exp-table", {
            data:data, //set initial table data
            layout:"fitDataFill",
            initialSort:[{column:"fiscal_year", dir:"desc"}],
            columns:[
                {title:"Fiscal Year", field:"fiscal_year"}, 
                // {title:"2019", field:"fy_2019", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
                {title:"Total Expenditure", field:"total", sorter:"number", formatter: money_formatter},
            ]
        });
    });
    window.build_expenditure_by_institution_table = build_expenditure_by_institution_table; // Added to explicitly define function for the React side of things 
  }

  // New version - shows data - changed to window so help on the React side of things
  window.build_detail_expenditure_by_institution_table = function(entities, fiscal_years){
  // const build_detail_expenditure_by_institution_table = function(entities, fiscal_years){
    entities = entities || window.selectedEntities || [];
    fiscal_years = fiscal_years || window.selectedYears?.map(Number) || [];

    // New D3 Method
    d3.csv("/data/expenditure_by_institution_entity.csv").then(buildDetailResponse => {
      const data = Array.isArray(buildDetailResponse) // Added by Matt to fix JS errors
      ? buildDetailResponse.filter(el => entities.includes(el.entity_name))
      : [];

      var money_formatter = function(cell, formatterParams, onRendered){
        const cell_value = cell.getValue()
        return d3.format("$.3s") (cell_value).replace(/G/,"B");
      }

      // determine which columns to show

    //   [
    //     {title:"Expenditure Category", field:"higher_ed_entity",  frozen:true}, // sticky column
    //     // {title:"2019", field:"fy_2019", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
    //     {title:"2020", field:"fy_2020", sorter:"number", formatter: money_formatter},
    //     {title:"2021", field:"fy_2021", sorter:"number", formatter: money_formatter},
    //     {title:"2022", field:"fy_2022", sorter:"number", formatter: money_formatter},
    //     {title:"2023", field:"fy_2023", sorter:"number", formatter: money_formatter},
    //     {title:"2024", field:"fy_2024", sorter:"number", formatter: money_formatter},
    //     ,
    // ]

      let cols_array =[{title:"Expenditure Category", field:"higher_ed_entity",  frozen:true}]
  
      // now loop through years and add 
      fiscal_years.forEach(year_str => {
        cols_array.push({
          title: `${year_str}`,
          field: `fy_${year_str}`,
          sorter:"number",
          formatter:money_formatter
        })
      });

      // build initial sort:
      const initial_sort = [{column:`fy_${Math.max(fiscal_years)}`,
        dir:"desc"}]

      var table = new Tabulator("#institution-detail-exp-table", {
          data:data, //set initial table data
          // layout:"fitDataFill", // Removed to look better on mobile
          layout: "fitData",
          initialSort:initial_sort,
          columns:cols_array
      });
    })
  }
  
  // Refactored version of B.F.T.E.B.I.B. with improved tooltip
  window.build_fte_by_institution_barchart = function(entities, fiscal_years){
    entities = entities || window.selectedEntities || [];
    fiscal_years = fiscal_years || window.selectedYears?.map(Number) || [];

    // New D3 Method
    d3.csv("/data/ushe_budget_annual_fte.csv").then(buildFteDataResponse => {
      const data = Array.isArray(buildFteDataResponse) // Added by Matt to fix JS errors
        ? buildFteDataResponse
            // Filter by selected fiscal years and entities
            .filter(el => fiscal_years.includes(+el.fiscal_year) && entities.includes(el.entity_name))
            .sort((a, b) => a.total - b.total)
        : [];

      var idcontainer = "institution-fte-bar-chart";
      d3.select("#"+idcontainer).selectAll("*").remove();

      // wipe the chart
      $("#"+idcontainer+"-container").empty();
      
      // Check if we need to add a disclaimer...
      let technical_colleges = [
        "Bridgerland Technical College",
        "Davis Technical College",
        "Dixie Technical College",
        "Mountainland Technical College",
        "Ogden-Weber Technical College",
        "Southwest Technical College",
        "Tooele Technical College",
        "Uintah Basin Technical College",
      ];

      let support_entities = ["Utah Education and Telehealth Network", "Utah System of Higher Education"];

      if (entities.some(e => technical_colleges.includes(e))) { 
        // put a disclaimer for technical colleges not having all FTE data available
        $("#"+idcontainer+"-container").append(`<div id="${idcontainer}"></div>
          <div class="alert alert-danger">Note: Budget-Related Annualized Full Time Enrollment (FTE) data could not be found from Utah System of Higher Education for FY 2020 and prior </div>`);
      } else if (support_entities.includes(entities)) {
        // put a disclaimer for support not having any FTE
        $("#"+idcontainer+"-container").append(`
          <div class="alert alert-warning">This is a support institution and does not have Full Time Enrollment data.</div>`);
        return;
      } else {
        $("#"+idcontainer+"-container").append(`<div id="${idcontainer}"></div>`);
      }

      var x_axis_label_offset = 25;
      var y_axis_label_offset = 0;
      // Define margins, widths and height for the plot
      var margin = { top: 10, right: 10, bottom: 60, left: 40 };
      if (window.matchMedia("(min-width: 768px)").matches) {
        margin = { top: 10, right: 10, bottom: 80, left: 80 };
        x_axis_label_offset = 60;
      }

      var container_width = $("#"+idcontainer+"-container").width();
      var width = container_width - margin.left - margin.right;
      var height = 3*container_width/4 - margin.top - margin.bottom;

      // Add the svg element to the body and set the dimensions and margins of the graph
      var svg = d3
        .select("#"+idcontainer)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      // Filtering Data to fix things (FY >= 2020)
      var filteredData = buildFteDataResponse
        .filter(d => fiscal_years.includes(+d.fiscal_year) && entities.includes(d.institution))
        // .filter(d => +d.fiscal_year >= 2020); // Removed to show all years

      // X axis scale
      var x = d3.scaleBand()
        .range([0, width])
        .domain(filteredData.map(d => d.fiscal_year))
        .padding(0.2);

      // Add x tick labels
      svg.append("g")
        .attr("class", "axisBlack")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x).ticks(d3.timeYear.every(1), d3.utcFormat("%y")))
        .selectAll("text")
        .attr("transform", "rotate(-45)")
        .style("text-anchor", "end");

      // add x axis label
      svg.append("text")
        .attr("class", "axisLabelBlack")
        .attr("transform", "translate(" + (width/2) + " ," + (height + margin.top + x_axis_label_offset) + ")")
        .style("text-anchor", "middle")
        .text("Fiscal Year");

      var formatDollarBillions2 = val => d3.format(".2s")(val).replace(/G/,"B");

      // determine min and max domain for y axis
      var val_max = d3.max(filteredData, d => +d.budget_annual_fte);

      // Add Y axis
      let y = d3.scaleLinear().domain([0, val_max]).range([height, 0]);

      svg.append("g")
        .attr("class", "axisBlack")
        .call(d3.axisLeft(y).tickFormat(formatDollarBillions2));

      // add y axis label
      svg.append("text")
        .attr("class", "axisLabelBlack")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - margin.left - y_axis_label_offset)
        .attr("x", 0 - (height / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text("Full Time Enrollment");

      // Tooltip (updated to match expenditure chart style)
      const tooltipId = `${idcontainer}-tooltip`;
      d3.select(`#${tooltipId}`).remove(); // remove old tooltip for this chart
      const tooltip = d3.select(`#${idcontainer}-container`)
        .append("div")
        .attr("id", tooltipId)
        .attr("class", "tooltip")
        .style("opacity", 0)
        .style("position", "absolute")
        .style("pointer-events", "none")
        .style("background", "#fff")
        .style("border", "1px solid #ccc")
        .style("padding", "8px")
        .style("border-radius", "4px")
        .style("z-index", 1000);

      function mouseover(event, d) {
        tooltip.transition().duration(100).style("opacity", 0.9);
        // Below version removed from tooltip.html to make formatting slightly different
        // <b>Budget Annualized FTE:</b> ${formatDollarBillions2(d.budget_annual_fte)}

        // Added to format commas in 4-6 digit numbers for enrollment
        const formatCommas = d3.format(",");

        tooltip.html(`
          <div>
            <p class="my-1"><strong>Institution:</strong> ${d.institution}</p>
            <p class="my-1"><strong>Year:</strong> ${d.fiscal_year}</p>
            <p class="my-1"><strong>Budget Annualized FTE:</strong> 
              <span class="badge badge-secondary p-1">
                ${formatCommas(d.budget_annual_fte)}
              </span>
            </p>
          </div>
        `);
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 0.2);
        d3.select(this).transition().duration(100).style("opacity", 1);
      }

      function mouseout(event, d) {
        tooltip.transition().duration(100).style("opacity", 0);
        d3.selectAll(`#${idcontainer} rect`).transition().duration(100).style("opacity", 1);
      }

      function tooltip_mousemove(event, d) {
        tooltip.style("left", (event.offsetX + 10) + "px")
              .style("top", (event.offsetY - 28) + "px");
      }

      // Init Bars
      svg.selectAll("mybar")
        .data(filteredData)
        .enter()
        .append("rect")
        .attr("x", d => x(d.fiscal_year))
        .attr("width", x.bandwidth())
        .attr("class", d => 'rect_' + d.fiscal_year)
        .attr("fill", "#ffc63a")
        .attr("y", d => y(d.budget_annual_fte))
        .attr("height", d => height - y(d.budget_annual_fte))
        .on("mouseover", mouseover)
        .on("mouseout", mouseout)
        .on("mousemove", tooltip_mousemove);

    }).catch(error => {
      console.log("There is an error loading CSV or building FTE chart: ", error);
    });
  };

  // New version - shows data
  window.build_fte_table = function(entities, fiscal_years){
    entities = entities || window.selectedEntities || [];
    fiscal_years = fiscal_years || window.selectedYears?.map(Number) || [];
 
    // New D3
    d3.csv("/data/ushe_budget_annual_fte.csv").then(buildFteDataResponse => {
      // Added by Matt to fix JS errors
      let data = Array.isArray(buildFteDataResponse)
      ? buildFteDataResponse
          .filter(el => entities.includes(el.institution) && fiscal_years.includes(+el.fiscal_year)) // Added to fix issues with too much data
      : [];
       
       var comma_format = function(cell, formatterParams, onRendered){
         const cell_value = cell.getValue()
         return d3.format(",.0f") (cell_value)
       }
 
       var table = new Tabulator("#institution-fte-table", {
           data:data,
           layout:"fitDataFill",
           initialSort:[{column:"fiscal_year", dir:"desc"}],
           columns:[
               {title:"Fiscal Year", field:"fiscal_year",  frozen:true}, // sticky column
               // {title:"2019", field:"fy_2019", sorter:"number", formatter: money_abbreviation_sequential_scale_format},
               {title:"Full Time Enrollment", field:"budget_annual_fte", sorter:"number", formatter: comma_format},
               ,
           ]
       });
    });
  }

  // Init the charts and tables
  build_higher_ed_waffle_chart()
  build_higher_exp_overtime_barchart()
  build_higher_exp_perc_overtime_barchart()
  build_institution_exp_barchart()
  build_activities_highlight_table()

  build_expenditure_by_institution_barchart()
  build_expenditure_by_institution_table()
  build_detail_expenditure_by_institution_table()
  build_fte_by_institution_barchart()
  build_fte_table()

  $('#select-entity').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
    build_expenditure_by_institution_barchart()
    build_expenditure_by_institution_table()
    build_detail_expenditure_by_institution_table()
    build_fte_by_institution_barchart()
    build_fte_table()
  });

  $('#select-year').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
    build_expenditure_by_institution_barchart()
    build_expenditure_by_institution_table()
    build_detail_expenditure_by_institution_table()
    build_fte_by_institution_barchart()
    build_fte_table()
  });
  
  build_sources()

  if (window.matchMedia("(min-width: 768px)").matches) {
    $("#all-activities-heatmap-table-warning").hide()
  }else{
    $("#all-activities-heatmap-table-warning").show()
  }

  window.addEventListener('resize',
    debounce(() => {
     build_higher_ed_waffle_chart()
     build_higher_exp_overtime_barchart()
     build_higher_exp_perc_overtime_barchart()
     build_institution_exp_barchart()
     build_activities_highlight_table()
 
     build_expenditure_by_institution_barchart()
     build_expenditure_by_institution_table()
     build_detail_expenditure_by_institution_table()
     build_fte_by_institution_barchart()
     build_fte_table()
    },
 200), false);
 
 window.addEventListener('orientationchange', 
   () => {
     build_higher_ed_waffle_chart()
     build_higher_exp_overtime_barchart()
     build_higher_exp_perc_overtime_barchart()
     build_institution_exp_barchart()
     build_activities_highlight_table()
 
     build_expenditure_by_institution_barchart()
     build_expenditure_by_institution_table()
     build_detail_expenditure_by_institution_table()
     build_fte_by_institution_barchart()
     build_fte_table()
   }, false);
  }

export function debounce(func, time) {
  var time = time || 100; // 100 by default if no param
  var timer;
  return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func, time, event);
  };
}

export function build_sources() {
  const sources_array = [
    // {fiscal_year:2001, soa_page:14, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehKsAAI"},
    // {fiscal_year:2002, soa_page:26, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehKxAAI"},
    // {fiscal_year:2003, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehL2AAI"},
    {fiscal_year:2004, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehL7AAI"},
    {fiscal_year:2005, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehLCAAY"},
    {fiscal_year:2006, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehLHAAY"},
    {fiscal_year:2007, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehLMAAY"},
    {fiscal_year:2008, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002eg2YAAQ"},
    {fiscal_year:2009, soa_page:28, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehJOAAY"},
    {fiscal_year:2010, soa_page:30, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002eg2OAAQ"},
    {fiscal_year:2011, soa_page:32, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002eg2TAAQ"},
    {fiscal_year:2012, soa_page:32, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002egJ5AAI"},
    {fiscal_year:2013, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehMKAAY"},
    {fiscal_year:2014, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehS8AAI"},
    {fiscal_year:2015, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehaSAAQ"},
    {fiscal_year:2016, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=01541000002ehhmAAA"},
    {fiscal_year:2017, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0154100000201ZcAAI"},
    {fiscal_year:2018, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0151K000003l0aGQAQ"},
    {fiscal_year:2019, soa_page:34, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0151K000003diIrQAI"},
    {fiscal_year:2020, soa_page:36, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0151K0000041eTuQAI"},
    {fiscal_year:2021, soa_page:36, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0151K000005SpBlQAK"},
    {fiscal_year:2022, soa_page:38, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=0151K000007bUMtQAM"},
    {fiscal_year:2023, soa_page:38, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=015Do0000017U3nIAE"},
    {fiscal_year:2024, soa_page:38, url:"https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=015Do0000017emoIAA"},
].sort((a,b)=>{return b.fiscal_year-a.fiscal_year});
            
  // build html elements
  var html_str = ``

  sources_array.forEach((source, index) => {
    html_str += `<li class="my-2"><a href="${source.url}" target="_blank" rel="noopener noreferrer" class="btn btn-wrap-text p-2 acfr-styles" style="background-color: #4A5568; color: white;">
                <i class="fa-regular fa-file-pdf mr-2"></i> State of Utah - ${source.fiscal_year} - Annual Comprehensive Financial Report</a>
            </li>`
  });

  let html_str2 = `<ul class="lead">${html_str}</ul>`

  $("#sources1").html(html_str2)
}

// New version
export function cartesianprod(...args) {
  function addTo(curr, args) {
    if (!args || !args.length || !Array.isArray(args[0]) || !args[0].length) return [];

    let copy, rest = args.slice(1), last = !rest.length, result = [];

    for (let i = 0; i < args[0].length; i++) {
      copy = curr.slice();
      copy.push(args[0][i]);

      if (last) {
        result.push(copy);
      } else {
        result = result.concat(addTo(copy, rest));
      }
    }

    return result;
  }

  return addTo([], args);
}

export function snake_caseify(text) {
  if (!text) return; // Added by Matt to Remove errors
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .trim();                        // Trim - from end of text
}

export function format_date_snakecase(date) {
  if (!date) return ''; // Added by Matt to fix errors
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}_${month}_${day}`;
}

export function getContrastYIQ(rgb_string) {
  // https://stackoverflow.com/questions/11867545/change-text-color-based-on-brightness-of-the-covered-background-area
  // var r = parseInt(hexcolor.substring(1,3),16);
  // var g = parseInt(hexcolor.substring(3,5),16);
  // var b = parseInt(hexcolor.substring(5,7),16);
  // var yiq = ((r*299)+(g*587)+(b*114))/1000;
  // return (yiq >= 128) ? 'black' : 'white';

  let rgb = d3.rgb(rgb_string)
  // console.log({"rgb": rgb,
  //   "rgb.r":rgb.r,
  //   "(rgb.r * 299)":(rgb.r * 299)

// })
  

  // http://www.w3.org/TR/AERT#color-contrast
  // const brightness = ((rgb.r * 299) +
  //                     (rgb.g * 587) +
  //                     (rgb.b * 114)) / 1000;
  // console.log("brightness: ", brightness)
  
  // return (brightness > 125) ? '#f8f9fa' : '#212529';


  const brightness = Math.sqrt((rgb.r * rgb.r * 0.241) +
                      (rgb.g * rgb.g * 0.691) +
                      (rgb.b * rgb.b * .068));
  
  // return (brightness > 130 ) ? '#212529' : '#f8f9fa'; // Commented out by Matt for newer implementation
  return brightness > 130 ? '#212529' : '#f8f9fa'; // Newer implementation
}